import React, {useContext} from 'react';
import OrganizationListPageTemplate from "../../../components/Templates/OrganizationListPageTemplate";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import {AuthContext} from "../../../context/AuthContext";

function OrgMedCenterList(props) {
    // const {medId, orgName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const userId = useContext(AuthContext)?.token?.userId
    const linkCell = (props) => {
        return <LinkCell3
            linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/allOrgList/orgHistory/${props.idArr[0]}/${props.cellContent}`}
            linkTitle={props.cellContent}
            editClick={_ => props.cellData.onClick(props.idArr[0])}/>
    }

    return (
        <OrganizationListPageTemplate
            getOrgListAPI={`/api/v2/verificationCenters/${userId}/organizations?`}
            roleIs={3}
            tableModel={{
                firstRow:
                    [
                        {title: 'Название', id: 'name',},
                        {title: 'Календарь'},
                        {title: 'Количество людей', id: '',},
                        {title: 'Вызов', id: ''},
                    ],
                haveToShow:
                    [
                        {id: 'org_name', type: 'wrapperCell', idArr: ['id'], typeData: {cell: linkCell}},
                        {id: 'id', type: 'wrapperCell', typeData: { cell: props => <IconCell iconName={'calendar'} to={process.env.REACT_APP_URL_PREFIX + `/calendar/${props.all.id}/${props.all.org_name}/`}/> } },
                        {id: 'patients_count'},
                        {id: 'invite_count'},
                    ]
            }
            }
            addOrgAPI={`/api/v2/verificationCenters/${userId}/organizations`}
            breadCrumbsItems={[
                {title: 'Контрагенты'},
                {title: "Организации", actual: true},
            ]}/>
    );
}

export default OrgMedCenterList;

